import {ActionType, CleanResponse} from '../model';
import {BN} from "../model/misc";

type ConfirmOnBoardingType = (id: string, role: number, setPreferred: BN) => (dispatch: Function, store: Function, api: any) => Promise<any>;

export interface AdminActionsActType {
    confirmOnBoarding: ConfirmOnBoardingType
}

const ADMIN_ACTIONS_API_PATH = 'admin-actions';

const prefix = 'admin';
/**
 * Admin Actions Confirm OnBoarding for servicing (Ghost clients, ilia Agents, ilia IMOs)
 * @param id
 * @param role
 * @param setPreferred
 */
export const confirmOnBoarding: ConfirmOnBoardingType = (id, role, setPreferred = true) => async (dispatch, store, api) => {
    try {
        const payload = {id, role, setPreferred};
        const res: CleanResponse = await api.put(`${ADMIN_ACTIONS_API_PATH}/onboarding`, payload);

        dispatch({type: ActionType.ALERT, payload: {message: res.message, statusCode: 200}});

        return dispatch({type: ActionType.ADMIN_ACTIONS_ONBOARDING, payload: res.data});
    } catch (err) {
        dispatch({type: ActionType.ALERT, payload: err});
        throw err;
    }
};

export  const getAdminList = (query: { adminType: string }, force:boolean = false) => async (dispatch: Function, getState, api: any) => {
    try{
        const currentPage = getState().currentPage;
        // prevent api hit in case of data already exist
        if(!currentPage.adminList || force){
            let resp = await api.get(`${prefix}/list`, {}, query);
            // set in current page props
            console.log(resp);
            dispatch({
                type: ActionType.SET_PAGE_PROP,
                payload: { key:"adminList", value: resp },
            });
        }else{
            console.log(`prevent api hit`);
        }
    }catch (e) {
        dispatch({type: ActionType.ALERT, payload: e});
        throw e;
    }
}
